import useDodoableCollectionQuery from 'generated/api/dodoables/useDodoableCollectionQuery'
import LoadingScreen from 'app/components/LoadingScreen'
import DodoablesList from 'app/dodoables/list/Index'

export default () => {
  const { isPending, data: { dodoables } = {} } = useDodoableCollectionQuery({
    query: {
      active: true,
      slug: { start_with: 'training:strength:' }
    }
  })

  if (isPending) return <LoadingScreen />

  return (
    <div className="fcol flex-1">
      <h1>Birl</h1>
      <div className="flex-1 frow">
        <div className="flex-1 fcol">
          <h2> Sessions </h2>
          <DodoablesList dodoables={dodoables} />
          <div>
            {dodoables
              .map((dodoable) => {
                return dodoable.slug
              })
              .join(';')}
          </div>
        </div>
      </div>
    </div>
  )
}
